// eslint-disable-next-line import/no-named-as-default
import posthog from 'posthog-js';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const posthogKey = runtimeConfig.public.posthogPublicKey as string;

  if (!posthogKey) return;

  const posthogClient = posthog.init(posthogKey, {
    api_host: runtimeConfig.public.posthogHost as string,
    defaults: runtimeConfig.public.posthogDefaults as '2026-01-30',
    capture_pageview: false, // Manual tracking for SSR client-side navigation
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      recordCrossOriginIframes: true,
      maskAllInputs: true,
      maskTextSelector: '*' // Mask all text in session replays — PII safety
    },
    persistence: 'localStorage+cookie',
    opt_out_capturing_by_default: true, // GDPR — opt-in via cookie consent
    loaded: (ph) => {
      if (import.meta.env.MODE === 'development') ph.debug();
    }
  });

  // Tag every event so it can be distinguished from the mobile app in PostHog
  posthogClient.register({
    app: 'selvbetjening',
    platform: 'web'
  });

  // Manual pageview tracking for Nuxt SSR client-side navigation
  const router = useRouter();
  router.afterEach((to) => {
    posthog.capture('$pageview', { $current_url: to.fullPath });
  });

  return {
    provide: {
      posthog: () => posthogClient
    }
  };
});
